import { useState } from 'react';

import { useRiskRegisterStore } from 'store/riskRegister.store';

import { useQueryActivityLevelDrivers } from 'api/queries/activityLevelDrivers.query';

import { Pagination } from 'components/common/pagination/customPagination';

import { PER_PAGE, impactTypeOptions } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.utils';

export type UseActivityLevelDriversProvider = ReturnType<typeof useActivityLevelDriversProvider>;

export const useActivityLevelDriversProvider = ({ latestVersionId }) => {
    const { numOfIterations, riskIds, taskVersionHashCode, runQsra } = useRiskRegisterStore();
    const [pagination, setPagination] = useState<Pagination>({
        page: 1,
        size: PER_PAGE,
    });
    const [impactType, setImpactType] = useState<ISelectOption<'DAYS' | 'CORRELATION'>>(impactTypeOptions[0]);

    return {
        ui: {
            state: {
                pagination,
                impactType,
            },
            setters: {
                setPagination,
                setImpactType,
            },
        },
        api: {
            activityLevelDrivers: useQueryActivityLevelDrivers({
                riskIds,
                taskVersionHashCode,
                numOfIterations,
                metaDataId: latestVersionId,
                runQsra,
            }),
        },
    };
};
